import PropTypes from 'prop-types';
import { defineMessages } from 'react-intl';

export const HEADER_Y_AXIS_PADDING = 20;

export const PAGE_X_AXIS_PADDING_BY_BREAKPOINT = {
    XXSMALL: 15,
    XSMALL: 15,
    SMALL: 35,
    MEDIUM: 42,
    LARGE: 53,
    XLARGE: 60,
    XXLARGE: 60,
};

export const LOGIN_STATE = {
    LoggedOut: 0,
    SoftLoggedIn: 1,
    LoggedIn: 2,
};

export const USER_TYPE = {
    Patient: 0,
    Provider: 1,
    ZdEmployee: 2,
    BookingAgent: 9,
};

export const NOTIFICATION_TYPE = {
    ZocdocMessage: 'zocdocmessage',
    AppointmentConfirmed: 'appointmentconfirmed',
    AppointmentRescheduled: 'appointmentrescheduled',
    AppointmentCancelled: 'appointmentcancelled',
    AppointmentInfoNeeded: 'appointmentinfoneeded',
    AppointmentCheckIn: 'appointmentcheckin',
    AppointmentFeedback: 'appointmentfeedback',
    AppointmentAsyncBookingFailure: 'appointmentasyncbookingfailure',
};

export const STATE_KEYS = {
    User: 'user',
    LoginState: 'login_state',
    Notifications: 'notifications',
    UnseenNotificationCount: 'unseen_notification_count',
    UpcomingAppointments: 'upcoming_appointments',
    UserType: 'user_type',
};

export const LayoutPropTypes = {
    loginState: PropTypes.oneOf(Object.values(LOGIN_STATE)),
    userType: PropTypes.oneOf(Object.values(USER_TYPE)),
};

export const LOCALIZED_STRINGS = defineMessages({
    ATLANTA_URL: {
        id: 'Footer.AtlantaUrl',
        defaultMessage: '/primary-care-doctors/atlanta-218712pm',
    },
    CHICAGO_URL: {
        id: 'Footer.ChicagoUrl',
        defaultMessage: '/primary-care-doctors/chicago-210499pm',
    },
    DENVER_URL: {
        id: 'Footer.DenverUrl',
        defaultMessage: '/primary-care-doctors/denver-228319pm',
    },
    HOUSTON_URL: {
        id: 'Footer.HoustonUrl',
        defaultMessage: '/primary-care-doctors/houston-215108pm',
    },
    NYC_URL: {
        id: 'Footer.NycUrl',
        defaultMessage: '/primary-care-doctors/new-york-46063pm',
    },
    PHILADELPHIA_URL: {
        id: 'Footer.PhillyUrl',
        defaultMessage: '/primary-care-doctors/philadelphia-216871pm',
    },
    PHOENIX_URL: {
        id: 'Footer.PhoenixUrl',
        defaultMessage: '/primary-care-doctors/phoenix-220419pm',
    },
    SAN_ANTONIO_URL: {
        id: 'Footer.SanAntonioUrl',
        defaultMessage: '/primary-care-doctors/san-antonio-225141pm',
    },
    WASHINGTON_DC_URL: {
        id: 'Footer.DcUrl',
        defaultMessage: '/primary-care-doctors/washington-34993pm',
    },
    CHIROPRACTOR_URL: {
        id: 'Footer.ChiroUrl',
        defaultMessage: '/chiropractors',
    },
    DENTISTS_URL: {
        id: 'Footer.DentistUrl',
        defaultMessage: '/dentists',
    },
    DERMATOLOGIST_URL: {
        id: 'Footer.DermUrl',
        defaultMessage: '/dermatologists',
    },
    EYE_DOCTOR_URL: {
        id: 'Footer.EyeDoctorUrl',
        defaultMessage: '/eye-doctors',
    },
    OBGYN_URL: {
        id: 'Footer.ObGynUrl',
        defaultMessage: '/obgyns',
    },
    PRIMARY_CARE_URL: {
        id: 'Footer.PrimaryCareUrl',
        defaultMessage: '/primary-care-doctors',
    },
    PSYCH_URL: {
        id: 'Footer.PsychUrl',
        defaultMessage: '/psychiatrists',
    },
    BROWSE_LINK_GROUP_HEADER: {
        id: 'Layout.Footer.SEO.FindYourDoctor',
        defaultMessage: 'Look up your doctor',
    },
    SEARCH_LINK_GROUP_HEADER: {
        id: 'Layout.Footer.SEO.SearchZocdocMarketplace',
        defaultMessage: 'Search by',
    },
    CITIES_LINK_GROUP_HEADER: {
        id: 'Layout.Footer.SEO.Cities',
        defaultMessage: 'Cities',
    },
    SPECIALTIES_LINK_GROUP_HEADER: {
        id: 'Layout.Footer.SEO.Specialties',
        defaultMessage: 'Specialties',
    },
    HEALTH_SYSTEMS_LINK_GROUP_HEADER: {
        id: 'Layout.Footer.SEO.ZocdocForHealthSystems',
        defaultMessage: 'Zocdoc for health systems',
    },
});
